import api from "./revenuePlannerApi";

const uomConfiguration = {
  list: (accessToken) => api.get("/uomconfiguration/uomandcurrency", accessToken),
};

export default uomConfiguration;
